import type { ArtistRosterStatus } from '../types';

export function getRosterStatus(isOnRoster?: boolean): ArtistRosterStatus {
  if (isOnRoster === undefined) {
    return 'all';
  }

  return isOnRoster ? 'on_roster' : 'off_roster';
}
